export default class PhysicianSearchParameters {
    constructor(searchParams?: URLSearchParams) {
        const parseString = (key: string) => {
            if (searchParams == null) return null;
            return searchParams.get(key) ?? null;
        }

        const parseSearchParam = (key: string) =>  {
            if (searchParams == null) return null;
            return searchParams.get(key) ? parseInt(searchParams.get(key)) : null;
        }

        this.lastName = parseString("lastName");
        this.firstName = parseString("firstName");
        this.physicianId = parseSearchParam("physicianId");
        this.npi = parseString("npi");
        this.city = parseString("city");
        this.stateId = parseSearchParam("stateId");
        this.certificationId = parseSearchParam("certificationId");
        this.certificateNumber = parseSearchParam("certificateNumber");
        this.pageNumber = parseSearchParam("pageNumber");
        this.lNameCertificationId = null;
        this.stateCertificationId = null;
        this.certCertificationId = null;
    }

    lastName?: string;
    firstName?: string;
    physicianId?: number;
    npi?: string;
    city?: string
    stateId?: number;
    lNameCertificationId?: number;
    stateCertificationId?: number;
    certCertificationId?: number;
    certificationId?: number;
    certificateNumber?: number;
    pageNumber?: number;
}